import { useState } from "react";
import { ConfigurationState } from "../components/configuration/types";

export const useConfiguration = () => {
  const [state, setState] = useState<Omit<ConfigurationState, "formRefs">>({
    formData: {},
    isEditing: false,
    isModalOpen: false,
    modalType: null,
    selectedObject: null,
    selectedInfo: null,
    tempFormData: {},
    selectedHorizontalOption: "Minha Conta",
    selectedVerticalOption: "Dados Pessoais",
    expandedAccordion: null,
    filter: "",
    isModalExpanded: false,
    uploadedImage: "",
    productCategoryTableVisibleColumns: [
      "skuCategory",
      "skuCode",
      "skuName",
      "skuType",
      "skuUnitOfMeasure",
      "skuSuggestedPrice",
      "skuBarcode",
      "skuCreatedAt",
      "skuServiceTax",
      "skuUpdatedAt",
      "skuUpdatedBy",
    ],
    productGroupTableVisibleColumns: [
      "skuGroup",
      "skuProductionPrinterOrderType1",
      "skuProductionPrinterOrderType2",
      "skuProductionPrinterOrderType3",
      "skuCode",
      "skuName",
      "skuType",
      "skuUnitOfMeasure",
      "skuSuggestedPrice",
      "skuBarcode",
      "skuCreatedAt",
      "skuServiceTax",
      "skuUpdatedAt",
      "skuUpdatedBy",
    ],
  });

  const updateState = (newState: Partial<ConfigurationState>) => {
    setState((prev) => ({ ...prev, ...newState }));
  };

  const toggleAccordion = (accordionKey: string) => {
    setState((prev) => ({
      ...prev,
      expandedAccordion:
        prev.expandedAccordion === accordionKey ? null : accordionKey,
    }));
  };

  return {
    ...state,
    updateState,
    toggleAccordion,
  };
};
